import React, { useState, useEffect, useRef } from "react";
import { register, unregister } from "../../domain/socketSlice";
import styled, { css } from "styled-components";

// LogsPage Component
const LogsPage = () => {
  const [logs, setLogs] = useState({}); // State to hold structured logs by name
  const eventStats = useRef({}); // Ref to hold raw event stats

  const siteId = "66f11d80c8adb8d1ed21ae0e";
  const eventName = `play-mode-data-${siteId}`;

  useEffect(() => {
    register(eventName);
    window.addEventListener(eventName, onPlayModeData);

    return () => {
      unregister(eventName);
      window.removeEventListener(eventName, onPlayModeData);
    };
  }, []);

  const onPlayModeData = (playModeData) => {
    if (playModeData.detail.type !== "stats") {
      return;
    }
    const { name, ...rest } = playModeData.detail.data;

    // Update eventStats to keep only the last log per name
    eventStats.current[name] = rest;
    console.log("eventStats", eventStats.current);

    // Update logs state for rendering
    setLogs({ ...eventStats.current });
  };

  // Function to return the highlight class if the value is 0 or null
  const highlightZero = (key, value) => {
    switch (key) {
      case "status":
        return value !== "OK" ? "highlight" : "";

        break;
      case "delay":
        return value !== "OK" ? "highlight" : "";

        break;
      default:
        return value === 0 || value === null ? "highlight" : "";
    }
    return value === 0 || value === null ? "highlight" : "";
  };

  return (
    <Container>
      <h1>Logs Page</h1>
      <LogsWrapper>
        {Object.keys(logs).length > 0 ? (
          Object.entries(logs).map(([name, data]) => (
            <LogCard key={name}>
              <h2>{name}</h2>
              <pre>
                {/* Main Log Entries */}
                {Object.entries(data).map(([key, value]) => (
                  <LogEntry key={key} className={highlightZero(key, value)}>
                    <strong>{key}:</strong>
                    {value !== null && typeof value === "object" ? (
                      <pre></pre>
                    ) : (
                      JSON.stringify(value, null, 2)
                    )}
                  </LogEntry>
                ))}

                {/* Shelves Array */}
                {data.shelves &&
                  data.shelves.map((shelf, index) => (
                    <div key={index}>
                      <h3>Shelf: {shelf.shelfName}</h3>
                      {Object.entries(shelf).map(([key, value]) => (
                        <LogEntry key={key} className={highlightZero(value)}>
                          <strong>{key}:</strong>{" "}
                          {JSON.stringify(value, null, 2)}
                        </LogEntry>
                      ))}
                    </div>
                  ))}
              </pre>
            </LogCard>
          ))
        ) : (
          <p>No logs available.</p>
        )}
      </LogsWrapper>
    </Container>
  );
};

// Styled-components
const Container = styled.div`
  padding: 20px;
  font-family: Arial, sans-serif;
`;

const LogsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;

const LogCard = styled.div`
  flex: 1 1 calc(25% - 20px);
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background: #f9f9f9;
`;

const LogEntry = styled.div`
  background: #fff;
  padding: 10px;
  border-radius: 5px;
  overflow-x: auto;

  &.highlight {
    color: red;
  }
`;

export default LogsPage;
